<template>
  <div class="animated fadeIn" id="parametrizar-competencia">
    <div class="card card-default">
      <div class="card-header">
        <i class="icon-share"></i> Parametrização de Competência por Projeto
      </div>
      <div class="card-body">
        <datatable-panel :per-page="30"
          :url="`${$root.url}/projeto?token=${$root.usuario('access_token')}&${urlClienteNotNull}`"
          :fields="fields"
          :sortField="fields[0]"
          ref="datatable"
          :searchBar="searchBar">
        </datatable-panel>
      </div>
    </div>

    <notifications group="sincronizar-competencia" />
  </div>
</template>

<style lang="scss">
  #parametrizar-competencia {
    .details {
      width: 260px;
      text-align: center;

      .input-group {
        margin-bottom: 0 !important;
      }
    }

    .search-bar {
      & .container-fluid {
        padding-left: 0;

        & button {
          margin-left: 15px;
        }
      }
    }
  }
</style>

<script>
  import Vue from 'vue';

  import DatatablePanel from 'metawesome-datatable';
  import CustomActions from './CustomActions';
  import SearchBar from './SearchBar';
  import Uteis from '@/mixins/utils.js';

  Vue.component('actions-competencia', CustomActions);

  export default {
    components: {
      DatatablePanel,
    },

    mixins: [
      Uteis,
    ],

    data() {
      return {
        searchBar: SearchBar,
        fields: [
          { name: 'name', sortField: 'name', title: 'Nome', callback: this.formatarNome },
          { name: 'centro_custo_sap', sortField: 'centro_custo_sap', title: 'Código do Centro de Custo', },
          { name: '__component:actions-competencia', title: 'Competência', titleClass: 'details', dataClass: 'details', },
        ],
        urlClienteNotNull: '&filter=%7B%22cc_id_not_null%22:true%7D',
      };
    },
    // Elemento VUE
  }
</script>
